module.exports = __webpack_public_path__ + "static/media/javascript.7f130501.webp";